<template>
  <div class="screen-whole">
    <h1 class="title has-text-centered">デフォルト値設定一覧</h1>
    <div class="content-area">
      <div class="content-header">
        <b-button :disabled="(isDealer && !institutionId) || cpapDefaultSettingList.length >= 15" style="justify-self: start;" class="is-primary" @click="selectCpapDefaultSetting(null)"
          >+新規作成</b-button
        >
        <div v-if="isDealer" style="justify-self: center;">
          <span>医療機関名</span>
          <input type="text" style="width:450px;" v-model="medicalInstitutionName" name="医療機関名" disabled/>
          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
        </div>
        <span class="result-count" style="justify-self: end; white-space: nowrap;">件数：{{cpapDefaultSettingList.length}}件</span>
      </div>
    </div>
    <div class="result-area">
      <b-table
        :data="cpapDefaultSettingList"
        :columns="columns"
        class="cpap-default-setting-list"
        default-sort="updatedAt"
        default-sort-direction="desc"
      >
        <template slot-scope="props">
          <b-table-column class="edit-icon" label="編集" width="50" centered>
            <a @click="selectCpapDefaultSetting(props.row.id)">
              <b-icon icon="clipboard-edit-outline" />
            </a>
          </b-table-column>
          <b-table-column field="templateName" label="テンプレート名" sortable>
            {{ props.row.templateName }}
          </b-table-column>
          <b-table-column field="itemName" label="機種" width="250" sortable>
            {{ props.row.itemName }}
          </b-table-column>
          <b-table-column field="mode" label="モード" width="150" sortable>
            {{ props.row.displayMode }}
          </b-table-column>
          <b-table-column field="createdAt" label="作成日" width="150" sortable>
            {{ props.row.createdAt }}
          </b-table-column>
          <b-table-column field="updatedAt" label="更新日" width="150" sortable>
            {{ props.row.updatedAt }}
          </b-table-column>
          <b-table-column field="delete" label="削除" width="50"
            ><button
              class="delete-button"
              @click="del(props.row)"
            >
              <b-icon icon="delete-forever-outline" /></button
          ></b-table-column>
        </template>

        <template #empty>
          <div class="has-text-centered">保存されているデフォルト値設定はありません</div>
        </template>
      </b-table>
      <div class="align-right">
        <b-button class="is-primary" @click="backToMenu"
          >戻る</b-button
        >
      </div>
    </div>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <facilitySelectModal :dealerId="belongsId" @select="setfacility"></facilitySelectModal>
    </b-modal>
  </div>
</template>

<script>
import {
  cpapKindMap,
} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";

export default {
  components: {
    facilitySelectModal:FacilitySelectModal
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var modelList = this.getCpapMaster();
    var roleId = userInfo.roleId;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;

    return {
      modelList: modelList,
      cpapDefaultSettingList: [],
      organizationModalActive: false,
      isHospital:isHospital,
      isDealer:isDealer,
      belongsId: "",
      institutionId: "",
      medicalInstitutionName:"",
      cpapKindMap:cpapKindMap,
      columns: [
        {
          field: "edit",
          label: "編集",
          sortable: false,
        },
        {
          field: "templateName",
          label: "テンプレート名",
          sortable: true,
        },
        {
          field: "itemName",
          label: "機種",
          sortable: true,
        },
        {
          field: "displayMode",
          label: "モード",
          sortable: true,
        },
        {
          field: "createdAt",
          label: "作成日",
          sortable: true,
        },
        {
          field: "updatedAt",
          label: "更新日",
          sortable: true,
        },
        {
          field: "delete",
          label: "削除",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    // back button
    backToMenu() {
      this.$router.push({ path: "CpapMenu" });
    },
    setfacility:  function(facility){
      this.institutionId = facility.id
      this.medicalInstitutionName = facility.orgName;
      this.doSearch();
    },
    doSearch: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalCpap.getCpapDefaultsettingsListPOST({
            body:{
              belongsId:_this.belongsId,
              institutionId: _this.institutionId
            }
          });
        },
        function(result){
          _this.cpapDefaultSettingList = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    selectCpapDefaultSetting(settingId) {
      const THIS = this;
      THIS.$router.push({
        name: "CpapDefaultSetting",
        params: { settingId: settingId, belongsId: this.belongsId, institutionId: this.institutionId, medicalInstitutionName: this.medicalInstitutionName }
      });
    },
    del: function(params) {
      this.$dialog.confirm({
        title: " ",
        message: `テンプレートを削除します。<br>一度削除すると元に戻せませんが、よろしいですか？`,
        confirmText:"OK",
        cancelText: "キャンセル",
        onConfirm: async() => {
          //API呼出し
          this.deleteCpapDefaultsettingsPOST(params);
        }
      });
    },
    deleteCpapDefaultsettingsPOST: function(params) {
      var obj = JSON.parse(JSON.stringify(params));
      obj.belongsId = this.belongsId
      obj.institutionId = this.institutionId
      obj.sendMedicalInstitutionFlag = obj.delivaryTarget=="hospital"
      const THIS = this;
      this.apiCall(
        (client) => {
          return client.apis.externalCpap.deleteCpapDefaultsettingsPOST({
            body: obj,
          });
        },
        (result) => {
          THIS.deleteCpapDefaultsettingsPOSTSuccess(result);
        },
        (error) => {
          THIS.deleteCpapDefaultsettingsPOSTError(error);
        }
      );
    },
    deleteCpapDefaultsettingsPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.doSearch();
      this.showSuccess(result);
    },
    deleteCpapDefaultsettingsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  created() {
    this.belongsId = JSON.parse(sessionStorage.getItem("userInfo")).belongsId;
  },
  mounted() {
    if (this.isDealer) {
      if (this.$route.params["institutionId"]) {
        this.institutionId = this.$route.params["institutionId"];
      }
      if (this.$route.params["medicalInstitutionName"]) {
        this.medicalInstitutionName = this.$route.params["medicalInstitutionName"];
      }
    }
    if(this.isHospital || (this.isDealer && this.institutionId && this.medicalInstitutionName)){
      this.doSearch();
    }
  },
};
</script>

<style scoped>
.screen-whole {
  width: 70%;
  margin: 1em auto;
}
.cpap-prescription-link {
  margin-bottom: 1em;
  font-size: 18px;
}
.cpap-prescription-link a {
  color: #2255ff;
  font-size: 18px;
  font-weight: bold;
}
.align-right {
  text-align: right;
}
.content-area {
  margin-top: 1em;
  margin-bottom: 1em;
}
.note {
  font-size: 18px;
}
.counting {
  margin-right: 1.5em;
  font-size: 18px;
}
.item-area {
  margin-top: 0.5em;
  padding: 1em;
  border: 1px solid;
  border-radius: 8px;
}
.cpap-default-setting-list {
  margin: 1em 0;
}

.cpap-default-setting-list a {
  color: #0d4794;
}

.cpap-default-setting-list a:hover {
  font-weight: bold;
}

.delete-button {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  border-width: thin;
  border-radius: 4px;
}
</style>

<style>
.switch-button .switch input + .check:before {
  background: #ffffff;
}
.cpap-default-setting-list .table-wrapper {
  border: 1px solid #cac8c8 !important;
  border-radius: 4px !important;
  max-height: 480px;
  overflow-y: auto;
  position: relative;
}
.cpap-default-setting-list table {
  padding: 0.5em;
}
.cpap-default-setting-list table th {
  position: sticky;
  top: 0;
  background: #ffffff;
}
.cpap-default-setting-list table th .th-wrap {
  font-weight: bold;
}
.cpap-default-setting-list table th,
.cpap-default-setting-list table td {
  font-size: 14px !important;
  vertical-align: middle;
}
.content-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;            /* 要素間の余白（お好みで） */
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapDefaultSettingList.vue